<template>
  <auth-shell title="إنشاء حساب مدرسة" subtitle="سجّل مدرستك وابدأ التحضير والإشعارات من اليوم.">
    <div class="auth-alert warn"><i class="fa fa-info-circle"></i><span>للمدارس فقط وليست لأولياء الامور ولا الطلاب.</span></div>
    <div class="auth-alert bad" v-if="error"><i class="fa fa-exclamation-circle"></i><span>{{ error }}</span></div>

    <label class="auth-field" for="reg-name">
      <span class="auth-label">اسم المدرسة</span>
      <span class="auth-input">
        <i class="fa fa-university"></i>
        <input id="reg-name" type="text" v-model="name" v-on:keyup.enter="onEnter" autocomplete="organization" placeholder="اكتب اسم المدرسة">
      </span>
    </label>

    <label class="auth-field" for="reg-phone">
      <span class="auth-label">الجوال <small>يكون عليه واتساب</small></span>
      <span class="auth-input">
        <i class="fa fa-whatsapp"></i>
        <input id="reg-phone" type="text" inputmode="tel" v-model="phone" v-on:keyup.enter="onEnter" autocomplete="tel" placeholder="05xxxxxxxx">
      </span>
    </label>

    <label class="auth-field" for="reg-password">
      <span class="auth-label">كلمة المرور</span>
      <span class="auth-input">
        <i class="fa fa-lock"></i>
        <input id="reg-password" :type="show ? 'text' : 'password'" v-model="password" v-on:keyup.enter="onEnter" autocomplete="new-password" placeholder="كلمة مرور للدخول لحسابك">
        <button type="button" class="auth-eye" @click="show = !show" :aria-label="show ? 'إخفاء كلمة المرور' : 'إظهار كلمة المرور'">
          <i :class="show ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        </button>
      </span>
    </label>

    <label class="auth-field" for="reg-location">
      <span class="auth-label">المنطقة</span>
      <span class="auth-input">
        <i class="fa fa-map-marker"></i>
        <select id="reg-location" v-model="location">
          <option value="">-- اختر المنطقة --</option>
          <option :value="location" v-for="location in locations" :key="location">
            {{ location }}
          </option>
        </select>
      </span>
    </label>

    <label class="auth-check" for="reg-ack">
      <input id="reg-ack" type="checkbox" v-model="checked">
      <span>أقر بأنني مدرسة ولست ولي أمر او طالب.</span>
    </label>

    <button class="auth-btn green" :disabled="!checked" @click="login()">
      إنشاء الحساب الآن <i class="fa fa-arrow-left"></i>
    </button>

    <p class="auth-alt">
      لديك حساب؟
      <a href="javascript:;" @click="$router.push('/login')">تسجيل الدخول</a>
    </p>
  </auth-shell>
</template>

<script>
import AuthShell from '../components/AuthShell.vue';

export default {
    components: { AuthShell },
    created(){
        var g = this;
        $.post(api + '/user/auth/locations').then(function(e){
            g.locations = e.response
        })
    },
    data(){
        return {
            checked: false,
            phone: "",
            password: "",
            name: "",
            error: null,
            location: "",
            locations: [],
            code: window.location.hash ? window.location.hash.replace("#", "") : null,
            show: false
        }
    },
    methods: {
        onEnter: function() {
            this.login()
        },
        login(){
            var g = this;
            g.error = null;
            if(!g.location || g.location == ""){
                return alert("برجاء اختيار المنقطة", 200)
            }
            $.post(api + '/user/auth/register', {
                phone: g.phone,
                password: g.password,
                name: g.name,
                code: g.code,
                location: g.location
            }).then(function(r){
                if(r.status != 100){
                    g.error = r.response
                }else{
                    localStorage.setItem("user", JSON.stringify(r.response))
                    window.location = '/activate'
                }
            }).fail(function(){
                g.error = "حدث مشكلة في الاتصال"
            })
        }
    }
}
</script>
